/* eslint-disable no-undef */
import React, { useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom';
import {Dropdown, Badge} from "react-bootstrap";


const ManageEquipmentTableRow = ({equipmentRequest: {id,initial_payment,balance,equipment_service_price, equipment_service_setting, createdAt, job_status}, sn}) => {

    let caution_fee = Number(parseFloat(equipment_service_setting.caution_fee)).toLocaleString();
    let service_price = Number(parseFloat(equipment_service_setting.service_price)).toLocaleString();
    const history = useHistory();

    useEffect(() => {
        //eslint-disable-next-line
    }, []);
    const hire = () => {
        history.push(`/farmer/checkout/${id}`)
    }
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    let date = new Date(createdAt)


    return (
        <tbody>
        <tr>
            <td>{sn}</td>
            <td>{equipment_service_setting.custom_name}</td>
            <td>₦{service_price}</td>
            <td>₦{caution_fee}</td>
            <td>
                {date.toLocaleDateString('en-GB',options)}
            </td>
            <td>
                {
                    job_status === 2 ? (
                            <div className="btn btn-outline btn-rounded button btn-block">
                                <Badge pill variant="success">Completed</Badge>
                            </div>
                        )
                        : job_status === 0 ? (
                            <div className="btn btn-outline btn-rounded button btn-block">
                                <Badge pill variant="warning">Pending</Badge>
                            </div>
                        )
                        : job_status === 1 ? (
                                <div className="btn btn-outline btn-rounded button btn-block">
                                    <Badge pill variant="primary">Started</Badge>
                                </div>
                            )
                            : (
                                <div className="btn btn-outline btn-rounded button btn-block">
                                    <Badge pill variant="danger">Cancelled</Badge>
                                </div>
                            )
                }
            </td>
            <td className="button-container">
                {job_status === 2 ? 
                <div className="action_options">
                <Dropdown>
                    <Dropdown.Toggle variant="dark btn-sm" id="dropdown-basic">
                        Action
                    </Dropdown.Toggle >
                    <Dropdown.Menu variant="dark btn-sm">
                        <button type="button" onClick={hire} className="btn button_style btn-sm btn-inverse-danger mr-2 waves-effect waves-light">Hire Again</button>
                        <Link to={{pathname: `/farmer/pay/balance/${id}`, query: {init: initial_payment,bal: balance,price: equipment_service_price, operator_charge: equipment_service_setting}}}><button type="button" className="btn button_style btn-sm btn-success waves-effect waves-light">Pay Balance</button></Link>
                    </Dropdown.Menu>
                </Dropdown>
            </div> : ""}
            </td>
        </tr>
        </tbody>
    )
}

export default ManageEquipmentTableRow
